export const apiDomain = process.env.NODE_ENV === 'production' ? '' : ''
 
export const api = {
  checkSignin: apiDomain + '/admin/Index/checkSignin'
}
